import { ROOTSTOCK } from '../types';
export default {
  type: ROOTSTOCK,
  service: 'RSK Public Websocket',
  url: 'wss://nodes.mewapi.io/ws/rsk',
  auth: null,
  username: '',
  password: ''
};
